import { object, InferType } from 'yup';
import { configService } from '../../services';

export const DealRegFormSchema = object(configService.current().opportunityManagementProps.dealRegForm?.filter((val: any) => true)[0].dealRegFormSchema);  

export interface DealRegFormValues extends InferType<typeof DealRegFormSchema> {}